module.exports = __webpack_public_path__ + "assets/img/shu_03.211bd84a.png";